import { wijzneusApi } from './wijzneus-api';
const getSeasonsDropdown = () => {
    return wijzneusApi.get(`seasons/dropdown`);
};
const SeasonApi = {
    getSeasonsDropdown
};
export default SeasonApi;
